import React from "react";
import { connect } from "react-redux";

import TextHighlighter from "@app/component/TextHighlighter";
import { RootState } from "@app/store/rootReducer";

import { getParentEmailThreadsSearchText } from "../store/selectors";

interface SearchTextHighlighterProps {
  className?: string;
  searchText: string;
  text: string;
}

const SearchTextHighlighter: React.FC<SearchTextHighlighterProps> = ({
  className,
  searchText,
  text,
}) => {
  return <TextHighlighter className={className} searchText={searchText} text={text} />;
};

const mapStateToProps = (state: RootState) => ({
  searchText: getParentEmailThreadsSearchText(state),
});

export default connect(mapStateToProps)(SearchTextHighlighter);
